import { memo, useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import Filters from "components/Filters";
import FiltersContentWrapper from "components/Filters/ContentWrapper";
import FiltersSidebar from "components/Filters/Sidebar";
import FiltersSplit from "components/Filters/Split";
import { SavedFilterView } from "components/Filters/types";
import { AnalyticsPageModule } from "hooks/useAnalytics/pages/module";

import {
  FILTER_TYPE,
  FILTERS_ORDER_SETTINGS_KEY,
  INITIAL_SORT_DIRECTION,
  INITIAL_SORT_OPTION,
} from "../constants";
import { SEARCH_MODULES_SUGGESTIONS_DICTIONARY } from "./constants";
import useModulesFilters from "./useModulesFilters";
import useModulesStore from "../useModulesStore";

type ModulesFiltersLayoutProps = {
  children: React.ReactNode;
  currentSavedView?: SavedFilterView;
  setCurrentSavedView: (view?: SavedFilterView) => unknown;
  titleId?: string;
};

const ModulesFiltersLayout = ({
  children,
  currentSavedView,
  setCurrentSavedView,
  titleId,
}: ModulesFiltersLayoutProps) => {
  const { filters, filtersMap, loading, itemsCount, sortOptions, refreshSuggestions } =
    useModulesFilters();

  const { setAllItemsQty } = useModulesStore(
    useShallow((state) => ({
      setAllItemsQty: state.setAllItemsQty,
    }))
  );

  useEffect(() => {
    setAllItemsQty(itemsCount);
  }, [itemsCount, setAllItemsQty]);

  return (
    <Filters
      filters={filters}
      filtersItemsOptionsMap={filtersMap}
      filtersLoading={loading}
      sortOptions={sortOptions}
      initialSortOption={INITIAL_SORT_OPTION}
      initialSortDirection={INITIAL_SORT_DIRECTION}
      pollActiveSections={refreshSuggestions}
      filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
      filtersDictionary={SEARCH_MODULES_SUGGESTIONS_DICTIONARY}
      filtersType={FILTER_TYPE}
      currentSavedView={currentSavedView}
      setCurrentSavedView={setCurrentSavedView}
    >
      <FiltersSplit>
        <FiltersSidebar analyticsPage={AnalyticsPageModule.ModulesList} />

        <FiltersContentWrapper titleId={titleId}>{children}</FiltersContentWrapper>
      </FiltersSplit>
    </Filters>
  );
};

export default memo(ModulesFiltersLayout);
